export default {
  "itemOwner": "Tulajdonos",
  "itemOwners": "Tulajdonosok",
  "name": "Név",
  "name-invalid": "A név érvénytelen. Minimum 1 és maximum 60 karakter lehet.",
  "add": "Tulajdonos hozzáadása",
  "back": "Vissza a listához",
  "save": "Tulajdonos mentése",
  "action": "Műveletek",
  "id": "Azonosító",
  "status": "Státusz",
  "translStatus": "Státusz",
  "ACTIVE": "Aktív",
  "INACTIVE": "Inaktív",
  "erpId": "Forrás.NET #",
};